import { cn, getUnknownToken } from "@/domains/library"

export type ITokenIcon = {
  symbol: string
  imageURL: string
}

export const TokenIcon = ({ token, className, size }: { token: ITokenIcon; size: number; className?: string }) => {
  return (
    <img
      className={cn("aspect-square", className)}
      src={token.imageURL}
      width={size ?? 32}
      height={size ?? 32}
      alt={token.symbol}
      onError={(event: React.SyntheticEvent<HTMLImageElement, Event>) => {
        const target = event.currentTarget
        target.onerror = null
        target.src = getUnknownToken()
      }}
    />
  )
}
